export default {
  SET_LOADING(state, status) {
    state.loading = status;
  },

  SET_BUSINESS_ADDRESSES(state, businessAddresses) {
    state.businessAddresses = businessAddresses;
  }
};
